export const LOADING_QUOTATIONS = "LOADING_QUOTATIONS";
export const GET_QUOTATIONS_LIST = "GET_QUOTATIONS_LIST";
export const REMOVE_QUOTATIONS = "REMOVE_QUOTATIONS";
export const ADD_QUOTATIONS = "ADD_QUOTATIONS";
export const UPDATE_QUOTATIONS = "UPDATE_QUOTATIONS";
export const GET_QUOTATION_ID = "GET_QUOTATION_ID";

export const LOADING_QUOTATION_DOCUMENT = "LOADING_QUOTATION_DOCUMENT";
export const REMOVE_QUOTATION_DOCUMENT = "REMOVE_QUOTATION_DOCUMENT";
export const ADD_QUOTATION_DOCUMENT = "ADD_QUOTATION_DOCUMENT";
export const ADD_QUOTATION_MULTI_DOCUMENT = "ADD_QUOTATION_MULTI_DOCUMENT";
export const DOWNLOAD_QUOTATION_DOCUMENT = "DOWNLOAD_QUOTATION_DOCUMENT";
export const GET_QUOTATION_DOCUMENT_LIST = "GET_QUOTATION_DOCUMENT_LIST";